import { useMutation } from '@tanstack/react-query';
import { profileApi, type UpdateProfileRequest } from '../services/profileApi';

export const useUpdateProfile = () => {
  return useMutation({
    mutationFn: (payload: UpdateProfileRequest) => profileApi.updateProfile(payload),
  });
};
